import get from 'lodash/get';
import {
  extractLotameInterestsFromNowPlaying,
  extractLotameInterestsFromGuideItem,
} from '../utils/ads/lotameUtils';
import { sendLotameInterests } from './mint';

export const SHARING_FROM_PLAYER = 'SHARING_FROM_PLAYER';
export const SHARING_FROM_PROFILE = 'SHARING_FROM_PROFILE';

export function sharingFromPlayer() {
  return (dispatch, getState) => {
    const nowPlaying = get(getState(), 'player.nowPlaying');
    const lotameVariables = extractLotameInterestsFromNowPlaying(nowPlaying);

    dispatch(sendLotameInterests(lotameVariables));

    return dispatch({
      type: SHARING_FROM_PLAYER,
    });
  };
}

export function sharingFromProfile(guideItem) {
  return (dispatch, getState) => {
    const tunedGuideId = get(getState(), 'player.tunedGuideId');
    if (tunedGuideId === get(guideItem, 'guideId')) {
      const nowPlaying = get(getState(), 'player.nowPlaying');
      const lotameVariables = extractLotameInterestsFromNowPlaying(nowPlaying);

      dispatch(sendLotameInterests(lotameVariables));
    } else {
      const lotameVariables = extractLotameInterestsFromGuideItem(guideItem);

      dispatch(sendLotameInterests(lotameVariables));
    }

    return dispatch({
      type: SHARING_FROM_PROFILE,
    });
  };
}
